import { AppIdentifier, OnboardingPage } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED,
  ACTION_SET_NAVIGATE
} from "./constants";

export interface IOnboardingState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
  navigate?: OnboardingPage;
}

export interface IOnboardingAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
  navigate?: OnboardingPage;
}

const INITIAL_STATE: IOnboardingState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: IOnboardingState, action: IOnboardingAction) : IOnboardingState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: IOnboardingState, action: IOnboardingAction) : IOnboardingState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: IOnboardingState, action: IOnboardingAction) : IOnboardingState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}
const applySetNavigate = (state: IOnboardingState, action: IOnboardingAction): IOnboardingState => {
  return {
    ...state,
    navigate: action.navigate,
  }
}

const reducerMap: { [actionType: string]: (state: IOnboardingState, action: IOnboardingAction) => IOnboardingState } = {
  // Onboarding reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.ONBOARDING)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.ONBOARDING)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.ONBOARDING)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.ONBOARDING)}${ACTION_SET_NAVIGATE}`]: applySetNavigate,
};

const onboardingReducer = (state = INITIAL_STATE, action: IOnboardingAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default onboardingReducer;
